<span class="caption">Set point colors based on</span>
<mat-form-field
  ><mat-select
    [value]="pointColorModeStore.$ | async"
    (selectionChange)="updatePointColorMode($event.value, { source: 'select' })"
  >
    <mat-option
      *ngFor="let option of pointColorModeOptions$ | async"
      [value]="option.mode"
    >
      {{ option.label | titlecase }}
    </mat-option>
  </mat-select>
</mat-form-field>

@switch (pointColorModeStore.$ | async) {
  @case (PointColorMode.Intensity) {
    <h3-view-settings-range-slider
      [defaultValue]="defaultIntensityRange"
      [config]="intensityRangeConfig"
      [settingStore]="intensityRangeStore"
      label="Intensity range"
      settingName="intensity_range"
      suffix=""
    ></h3-view-settings-range-slider>
  }

  @case (PointColorMode.Height) {
    <h3-view-settings-range-slider
      [defaultValue]="defaultHeightFromLocation"
      [config]="heightFromLocationConfig"
      [settingStore]="heightRangeStore"
      label="Height"
      settingName="height_range"
      suffix=""
    ></h3-view-settings-range-slider>
  }

  @case (PointColorMode.Sensor) {
    <section>
      <ul class="sensor-list">
        <li *ngFor="let sensor of sensors$ | async">
          <h3-sensor-color-option
            [sourceId]="sensor.source_id"
            [label]="sensor.label"
            [sensorSelectionTracker]="sensorSelectionTracker"
          >
          </h3-sensor-color-option>
        </li>
      </ul>
    </section>
  }
}
